<script>
    export default {
        name: "UserMenu",
        props: {
            profile: Object
        }
    };
</script>


<style lang="scss">
    .user-menu {
        font-size: 0.85em;
        color: #666;
        display: flex;
        align-items: center;

        img {
            height: 32px;
            width: 32px;
            border-radius: 50%;
        }
    }
</style>


<template>
    <div class="user-menu" v-if="profile">
        <img v-bind:src="profile.gravatar" />
        <!--
        <div>
            Logged in as
            <b>
                {{ profile.email }}
            </b>
        </div>
        -->

    </div>
</template>

